import React from "react";
import styled from "styled-components";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import syntalix from "../img/IMG_20231218_101705.png"

// ... (import statements)

const Container = styled.div`
  position: sticky;
  top: 0;
  height: 56px;
  background-color: rgba(20, 20, 20, 0.132);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(5px);
  z-index: 1000;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  padding: 0px 20px;
  position: relative;
`;

const Search = styled.div`
  width: 40%;
  position: absolute;
  left: 0px;
  right: 0px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px;
  border: 1px solid #dacdcd;
  border-radius: 10px;
  @media (max-width: 768px) {
    width: 70%;
  }
`;

const Input = styled.input`
  border: none;
  background-color: transparent;
  outline: none;
  color: ${({ theme }) => theme.text};
`;

const Button = styled.button`
  padding: 5px 15px;
  background-color: transparent;
  border: 1px solid #3ea6ff;
  color: #3ea6ff;
  border-radius: 10px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const SyntalixIcon = styled.img`
  height: 25px;
  cursor: pointer;
  display: none;

  @media (max-width: 768px) {
    display: block; // Adjust the margin as needed
  }
`;

const Navbar = () => {
  return (
    <Container>
      <Wrapper>
        <SyntalixIcon src={syntalix} alt="Syntalix" />
        <Search>
          <Input placeholder="Search" />
          <SearchIcon style={{ color: "white" }} />
        </Search>
        <Link to="signin" style={{ textDecoration: "none" }}>
          <Button>
            <AccountCircleOutlinedIcon />
            SIGN IN
          </Button>
        </Link>
      </Wrapper>
    </Container>
  );
};

export default Navbar;
